<template>
  <section :class="['article-header', 'section', bgClass, sectionTypeClass]">
        <div class="container">
            <!-- Float/wrap variant: image floats, text wraps around it -->
            <div v-if="floatImage" class="article-header__wrap">
                <div class="article-header__wrap-img">
                    <slot name="secondCol" />
                </div>
                <slot name="firstCol" />
            </div>
            <!-- Default two-column variant -->
            <div
                v-else
                class="row"
                :class="
                    reverseMobile ? 'flex-column-reverse flex-md-row' : null
                "
            >
                <div class="col-md-6">
                    <div class="article-header__first-col">
                        <slot name="firstCol" />
                    </div>
                </div>
                <div class="col-md-6">
                    <slot name="secondCol" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: {
            sectionTypeClass: {
                type: String,
                default: ''
            },
            reverseMobile: {
                type: Boolean,
                default: true
            },
            bgClass:{
              type: String,
              default: 'bg--light'
            },
            floatImage: {
                type: Boolean,
                default: false
            }
        }
    };
</script>
